export const returnProductWithComments = (ratingsArray) => {
    return ratingsArray?.filter((rating) => rating.comment !== null && typeof ratingsArray?.comment !== 'undefined');
}